import React from 'react';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export default function FileTree({ fileTree, expandedNodes = {}, selectedFilePath = '', normalizePath, onToggleDir, onSelectFile, badgesForPath }) {
  if (!fileTree) return (<Typography sx={{ color: '#7d8590' }}>No files</Typography>);

  const renderTree = (node, depth = 0) => {
    const entries = Object.values(node.children || {}).sort((a, b) => {
      const aIsDir = Object.keys(a.children).length > 0 && !a.file;
      const bIsDir = Object.keys(b.children).length > 0 && !b.file;
      if (aIsDir !== bIsDir) return aIsDir ? -1 : 1;
      return a.name.localeCompare(b.name);
    });
    return entries.map((child) => {
      const isDir = Object.keys(child.children).length > 0 && !child.file;
      if (isDir) {
        const open = !!expandedNodes[child.path];
        return (
          <Box key={child.path}>
            <ListItemButton onClick={() => onToggleDir(child.path)} sx={{ pl: 1.5 + depth * 1.5, '&:hover': { backgroundColor: '#21262d' }, color: '#c9d1d9' }}>
              <ListItemIcon sx={{ minWidth: 28, color: '#7d8590' }}>{open ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}</ListItemIcon>
              <FolderIcon sx={{ mr: 1, color: '#8b949e' }} fontSize="small" />
              <ListItemText primaryTypographyProps={{ fontSize: 13 }} primary={child.name} />
            </ListItemButton>
            {open && (<Box sx={{ ml: 3 }}>{renderTree(child, depth + 1)}</Box>)}
          </Box>
        );
      }
      const isSelected = normalizePath(selectedFilePath) === normalizePath(child.path);
      const childKey = normalizePath(child.path);
      const badges = typeof badgesForPath === 'function' ? badgesForPath(childKey) : null;
      return (
        <ListItemButton key={child.path} onClick={() => onSelectFile(childKey)} selected={isSelected} sx={{ pl: 5 + depth * 1.5, borderRadius: 1, '&.Mui-selected': { backgroundColor: '#1f6feb20' }, '&:hover': { backgroundColor: '#21262d' }, color: '#c9d1d9' }}>
          <ListItemIcon sx={{ minWidth: 24 }}><InsertDriveFileIcon sx={{ color: '#8b949e' }} fontSize="small" /></ListItemIcon>
          <Tooltip title={child.path} placement="right"><ListItemText primaryTypographyProps={{ fontSize: 13, noWrap: true }} primary={child.name} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mr: 1 }} /></Tooltip>
          {badges}
        </ListItemButton>
      );
    });
  };

  return (
    <List dense sx={{ color: '#c9d1d9' }}>
      {renderTree(fileTree, 0)}
    </List>
  );
}




